var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotConnectedIcon = function SvgNotConnectedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "NotConnectedIcon_svg__a",
    width: "130.9%",
    height: "151.5%",
    x: "-15.5%",
    y: "-25.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 0.25,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    "in": "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0.290221632 0 0 0 0 0.290175289 0 0 0 0 0.290237457 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "NotConnectedIcon_svg__b",
    d: "M11.021 9.663c-.894 0-1.57-.702-1.57-1.634 0-.937.676-1.64 1.57-1.64.892 0 1.568.703 1.568 1.64 0 .932-.676 1.634-1.568 1.634m0-4.117a2.46 2.46 0 0 0-1.932.92 2.5 2.5 0 0 0-.54-.637q-.018-.02-.053-.013a.06.06 0 0 0-.037.037l-.284.78c-.007.02 0 .041.01.06.23.296.359.656.359 1.043v4.523c0 .032.022.08.055.08h.728c.03 0 .05-.048.05-.08v-2.36l.036.03a2.5 2.5 0 0 0 1.605.577 2.445 2.445 0 0 0 2.473-2.471c0-1.395-1.083-2.489-2.47-2.489m-3.202.26h-.891c-.022 0-.043-.007-.05.013L5.04 9.386 3.2 5.822c-.014-.019-.033-.016-.057-.016h-.897c-.024 0-.043-.01-.055.008s-.012.03 0 .047l2.33 4.332c.019.036.156.313.518.313.361 0 .492-.271.516-.316L7.87 5.852c.01-.017.01-.018 0-.038-.013-.018-.03-.008-.051-.008"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CCC",
    d: "M16 14.47A1.53 1.53 0 0 1 14.466 16H1.53C.68 16 0 15.315 0 14.47V1.53C0 .686.68 0 1.53 0h12.936C15.316 0 16 .685 16 1.53z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#NotConnectedIcon_svg__b",
    fill: "#000",
    filter: "url(#NotConnectedIcon_svg__a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#NotConnectedIcon_svg__b",
    fill: "#FFF",
    stroke: "#FFF",
    strokeWidth: 0.5
  }))));
};
export default SvgNotConnectedIcon;